/* eslint-disable */
import React from 'react'

import PeriodOption from './PeriodOption'
import { FilterTypeContainer, FilterTypes, Container, Content, ListItem, Title } from './styles'

const filterItems = [
  {
    value: 15,
    label: '15 transações',
  },
  {
    value: 30,
    label: '30 transações',
  },
  {
    value: 60,
    label: '60 transações',
  },
  {
    value: 90,
    label: '90 transações',
  }
]

export default function PaginationSelector(onChange) {
  return (
    <Container>
      <Content>
        <Title>Visualizar</Title>
        <FilterTypeContainer>
          <FilterTypes>
            {filterItems.map((type) => (
              <ListItem key={type.value}>
                <PeriodOption
                  key={type.value}
                  value={type.value}
                  onChange={onChange}
                  name="quantidade"
                  label={type.label}
                />
              </ListItem>
            ))}
          </FilterTypes>
        </FilterTypeContainer>
      </Content>
    </Container>
  )
}




// WEBPACK FOOTER //
// ./src/app/pages/DashboardStatementPartner/PartnerStatementsFilter/PaginationSelector/PaginationSelector.js